import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(() => ({
  header: {
    marginBottom: 60,
    textAlign: 'center'
  },
  title: {
    position: 'relative'
    // '&:after': {
    //   content: "''",
    //   position: 'absolute',
    //   top: '50%',
    //   left: 0,
    //   width: '100%',
    //   height: 1,
    //   backgroundColor: theme.palette.primary.dark
    // },
    // '& span': {
    //   width: 'fit-content',
    //   backgroundColor: 'white'
    // }
  }
}))

export default useStyles
